import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { PlatformService } from "services/platform.service";

@Component({
	selector: 'ras-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.sass']
})
export class MenuComponent implements OnInit {

	@Output() close = new EventEmitter()
	@Input() set show(value) {
		this._show = value
		if (this.platform.isBrowser) {
			if (value) {
				if (this.timer) window.clearTimeout(this.timer)
				window.setTimeout(() => {
					this.timer = 0
					this.containerHeight = "none"
				}, 500)
				this.containerHeight = this.inner.nativeElement.getClientRects()[0].height + 'px'
			} else {
				if (this.timer) window.clearTimeout(this.timer)

				this.containerHeight = this.outer.nativeElement.getClientRects()[0].height + 'px'
				this.timer = window.setTimeout(() => {
					this.timer = 0
					this.containerHeight = '0px'
				}, 20)
			}
		}
	}
	public _show: boolean

	public containerHeight: string
	private timer: number

	@ViewChild('inner') inner
	@ViewChild('outer', { static: true} ) outer

	constructor(private platform: PlatformService) { }

	ngOnInit() {
	}

}
